import { render, staticRenderFns } from "./CustomTagsAIModal.vue?vue&type=template&id=48a19d26&scoped=true&"
import script from "./CustomTagsAIModal.vue?vue&type=script&lang=js&"
export * from "./CustomTagsAIModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsAIModal.vue?vue&type=style&index=0&id=48a19d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a19d26",
  null
  
)

export default component.exports